import React from 'react'

const Check = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.784" height="11.182" viewBox="0 0 15.784 11.182">
        <path id="check" data-name="Stroke 3" d="M0,4.082,4.084,8.165,12.249,0" transform="translate(1.768 1.768)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2.5"/>
    </svg>
)

export default Check
